import { render, staticRenderFns } from "./MyButton.vue?vue&type=template&id=9116b9d4&scoped=true&"
import script from "./MyButton.ts?vue&type=script&lang=ts&"
export * from "./MyButton.ts?vue&type=script&lang=ts&"
import style0 from "./MyButton.vue?vue&type=style&index=0&id=9116b9d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9116b9d4",
  null
  
)

export default component.exports